import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0","key":"svg-0"}],["path",{"d":"M10 12a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2l0 -7","key":"svg-1"}]]

const IconCircleSquare = createReactComponent('outline', 'circle-square', 'CircleSquare', __iconNode);

export default IconCircleSquare;